import * as Yup from 'yup';

export const ContactFormSchema = Yup.object().shape({
    firstname: Yup.string().required('Please enter your first name'),
    lastname: Yup.string().required('Please enter your last name'),
    email: Yup.string().required('Please enter your email').email('Please enter a valid email'),
    company: Yup.string().required('Please enter your company name'),
    title: Yup.string().required('Please enter your job title')
});